import { Component, Input, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  ActionSheetController,
  AlertController,
  ModalController,
  NavController,
  Platform,
} from '@ionic/angular';
import { CategoryResponse, CategoryStore } from 'src/app/stores/category.store';
import {
  ProductPayload,
  SellerProductStore,
  Variation,
} from 'src/app/stores/seller-product.store';
import { AddProductSubformComponent } from '../../shared-components/add-product-subform/add-product-subform.component';
import { InformationProductComponent } from '../../shared-components/information-product/information-product.component';
import { AddVariantPage } from '../add-variant/add-variant.page';
import { AdditionalInformationPage } from '../additional-information/additional-information.page';
import { LoaderService } from 'src/app/services/loader.service';
import { AddMoreInfoComponent } from 'src/app/shared-components/add-more-info/add-more-info.component';
import { NavigationExtras, Router } from '@angular/router';
import { Camera, CameraResultType } from '@capacitor/camera';
import {
  AuthenticationStore,
  ImageUploadResponse,
  LocationData,
} from 'src/app/stores/authentication.store';
import { AddLocationComponent } from 'src/app/shared-components/add-location/add-location.component';
import { currencyCode, imageUrl } from 'src/environments/environment';
import { Product, ProductStore } from 'src/app/stores/product.store';
import { TranslateService } from '@ngx-translate/core';
import { VideoModalComponent } from 'src/app/shared-components/video-modal/video-modal.component';

export class ProductDetail {
  static readonly UPLOAD_PHOTOS = new ProductDetail(
    'UPLOAD_PHOTOS',
    'ADD_PHOTOS.NAME'
  );
  static readonly CONDITIONS = new ProductDetail(
    'CONDITIONS',
    'CONDITIONS.NAME'
  );
  static readonly CATEGORY = new ProductDetail('CATEGORY', 'CATEGORY.NAME');
  static readonly SUB_CATEGORY = new ProductDetail(
    'SUB_CATEGORY',
    'SUB_CATEGORY.NAME'
  );
  static readonly VARIENT_TYPE = new ProductDetail(
    'VARIENT_TYPE',
    'VARIENT_TYPE.NAME'
  );
  static readonly ADD_VARIENT_TYPE = new ProductDetail(
    'ADD_VARIENT_TYPE',
    'VARIENT_TYPE.NAME'
  );
  static readonly SIZE_TYPE = new ProductDetail('SIZE_TYPE', 'SIZE_TYPE.NAME');

  static readonly ADD_SIZE_TYPE = new ProductDetail(
    'ADD_SIZE_TYPE',
    'ADD_SIZE_TYPE.NAME'
  );

  private constructor(
    private readonly type: string,
    private readonly title: string
  ) { }

  getType() {
    return this.type;
  }

  getTitle() {
    return this.title;
  }
}

@Component({
  selector: 'app-add-product',
  templateUrl: './add-product.page.html',
  styleUrls: ['./add-product.page.scss'],
})
export class AddProductPage implements OnInit {
  readonly imageUrl = imageUrl;
  readonly ProductDetail = ProductDetail;
  productForm: FormGroup;
  validation_errors: any;
  expandMore: boolean = false;
  product: ProductPayload = {
    product_name: null,
    category: null,
    subcategory: null,
    product_price: null,
    actual_price: null,
    product_description: null,
    product_condition: null,
    is_avail_delivery: null,
    is_avail_pickup: null,
    storage_locations: null,
    pickup_locations: null,
    sku: null,
    inventory: null,
    product_variation: [],
    product_img: [],
    product_fields: [],
    status: null,
    video_thumbnail: null,
    video_full: null,
    video_id: null,
    target_audience: null,
    is_rentable: null,
    rental_price: null,
    when_return_days: null,
  };
  productDetail: Product;
  categories: CategoryResponse;
  selectedCategoryName: string = 'Category';
  selectedSubCategoryName: string = 'Subcategory';
  subCategories: CategoryResponse;
  product_price: number;
  actual_price: number;
  variations: Array<Variation> = [];
  image: String = null;
  productId: number;
  currencyCode = currencyCode;
  base64String: string = '';
  @Input() productIdProp: number;
  isRental: boolean = false;
  constructor(
    private modalCtrl: ModalController,
    private alertController: AlertController,
    private FormBuilder: FormBuilder,
    private categoryStore: CategoryStore,
    private sellerProductStore: SellerProductStore,
    private loaderService: LoaderService,
    private router: Router,
    private actionSheetCtrl: ActionSheetController,
    public authenticationStore: AuthenticationStore,
    private productStore: ProductStore,
    private navController: NavController,
    private translate: TranslateService,
    public platform: Platform
  ) {}

  async ngOnInit() {
    const extraState = this.router?.getCurrentNavigation()?.extras?.state;
    if (extraState) {
      const { productId } = extraState;
      this.productId = productId;
      this.getProductDetail();
    } else if (this.productIdProp) {
      this.productId = this.productIdProp;
      this.getProductDetail();
    }
    this.refreshForm();
    this.getErrors();
    this.categories = await this.categoryStore.getCategory();
  }

  async dismissModal() {
    await this.modalCtrl.dismiss();
  }

  async refreshForm() {
    this.productForm = this.FormBuilder.group({
      product_name: new FormControl(
        this.productDetail ? this.productDetail.product_name : '',
        Validators.compose([Validators.required, Validators.minLength(5)])
      ),
      product_price: new FormControl(
        this.productDetail ? this.productDetail.product_price : '',
        Validators.compose([Validators.required])
      ),
      actual_price: new FormControl(
        this.productDetail ? this.productDetail.actual_price : '',
        Validators.compose([])
      ),
      product_description: new FormControl(
        this.productDetail ? this.productDetail.product_description : '',
        Validators.compose([Validators.required, Validators.minLength(25)])
      ),
      is_avail_delivery: new FormControl(),
      is_avail_pickup: new FormControl(),
      inventory: new FormControl(
        this.productDetail ? this.productDetail.inventory : '',
        Validators.compose([Validators.required])
      ),
      sku: new FormControl(
        this.productDetail ? this.productDetail.sku : '',
        Validators.compose([])
      ),
      target_audience: new FormControl(
        this.productDetail ? this.productDetail.target_audience : null,
        Validators.compose([])
      ),
      is_rentable: new FormControl(
        this.productDetail ? this.productDetail.is_rentable : null,
        Validators.compose([])
      ),
      rental_price: new FormControl(
        this.productDetail ? this.productDetail.rental_price : null,
        Validators.compose([])
      ),
      when_return_days: new FormControl(
        this.productDetail ? this.productDetail.when_return_days : null,
        Validators.compose([])
      ),
    });
    console.log(
      ' this.productForm?.value?.is_rentable',
      this.productForm?.value?.is_rentable
    );
    this.product.product_img = this.productDetail
      ? this.productDetail.images
      : [];
    this.product.product_condition = this.productDetail
      ? this.productDetail.product_condition
      : null;
    this.product.category = this.productDetail
      ? this.productDetail.category.id
      : null;
    this.product.subcategory = this.productDetail
      ? this.productDetail.subcategory.id
      : null;

    this.product.product_variation = this.productDetail
      ? this.productDetail.product_variations
      : [];
    this.product.product_fields = this.productDetail
      ? this.productDetail.product_fields
      : [];

    this.selectedCategoryName = this.productDetail
      ? this.productDetail.category.name
      : 'Category';
    this.selectedSubCategoryName = this.productDetail
      ? this.productDetail.subcategory.name
      : 'Subcategory';

    this.productForm.controls.is_avail_delivery.setValue(
      this.productDetail && this.productDetail.is_avail_delivery ? true : false
    );
    this.productForm.controls.is_avail_pickup.setValue(
      this.productDetail && this.productDetail.is_avail_pickup ? true : false
    );

    this.product.video_thumbnail = this.productDetail
      ? this.productDetail.video_thumbnail
      : null;
    this.product.video_full = this.productDetail
      ? this.productDetail.video_full
      : null;
    this.product.video_id = this.productDetail?.images.filter(
      (x) => x.type == 1
    )[0]?.id;
    if (this.productDetail) {
      this.getSubCategories();
    }
    this.productForm.controls.is_rentable.valueChanges.subscribe(
      (isRentable) => {
        this.updateRentalPriceValidators(isRentable);
      }
    );
    if (this.productForm.controls.is_rentable.value) {
      this.productForm.controls.rental_price.setValidators([
        Validators.required,
      ]);
      this.productForm.controls.when_return_days.setValidators([
        Validators.required,
      ]);
    }
  }

  async getProductDetail() {
    this.loaderService.showLoading();
    var resp = await this.productStore.getProductDetail(this.productId, true);
    if (resp.status == 1) {
      this.productDetail = resp.data.product;
      this.refreshForm();
    }
    this.loaderService.dismissLoading();
  }

  getErrors() {
    this.validation_errors = {
      product_name: [
        {
          type: 'required',
          message: `ADD_PRODUCT_SECTION.PRODUCT_NAME_REQUIRED`,
        },
        {
          type: 'minlength',
          message: `ADD_PRODUCT_SECTION.PRODUCT_NAME_LENGTH`,
        },
      ],
      product_price: [
        { type: 'required', message: `ADD_PRODUCT_SECTION.PRICE_REQUIRED` },
      ],
      // actual_price: [
      //   // {
      //   //   type: 'required',
      //   //   message: `ADD_PRODUCT_SECTION.ACTUAL_PRICE_REQUIRED`,
      //   // },
      // ],
      product_description: [
        {
          type: 'required',
          message: `ADD_PRODUCT_SECTION.DESCRIPTION_REQUIRED`,
        },
        {
          type: 'minlength',
          message: `ADD_PRODUCT_SECTION.DESCRIPTION_LENGTH`,
        },
      ],
      inventory: [
        { type: 'required', message: `ADD_PRODUCT_SECTION.INVENTORY_REQUIRED` },
      ],
      sku: [
        {
          type: 'required',
          message: `ADD_PRODUCT_SECTION.VARIATION.VARIATION_SUB_FORM.REQUIRED_SKU`,
        },
      ],

      rental_price: [
        {
          type: 'required',
          message: `PLACEHOLDER_TEXT.RENT_PRICE_REQUIRED`,
        },
      ],

      when_return_days: [
        {
          type: 'required',
          message: `PLACEHOLDER_TEXT.RETURN_DAYS_REQUIRED`,
        },
      ],
    };
  }

  async getSubformData(event: any) {
    this.getProductSubDetail(event);
  }

  async addProductDetail(detailType: ProductDetail) {
    // alert("here")
    const modal = await this.modalCtrl.create({
      component: AddProductSubformComponent,
      cssClass: 'add-photo',
      backdropDismiss: true,
      componentProps: {
        productDetailType: detailType,
        categories: this.categories,
        subCategories: this.subCategories,
      },
    });
    modal.present();
    var result = await modal.onDidDismiss();
    this.getProductSubDetail(result?.data);
  }

  getProductSubDetail(result) {
    if (result) {
      if (result.categoryId) {
        this.product.category = result.categoryId;
        this.selectedCategoryName = this.categories.data[result.index].name;
        this.getSubCategories();
        this.selectedSubCategoryName = 'Subcategory';
        this.product.subcategory = null;
        console.log(
          'this.productForm.controls.is_rentable.value',
          this.productForm.controls.is_rentable.value
        );
        if (this.productForm.controls.is_rentable.value) {
          this.updateRentalPriceValidators(false, true);
        }
      }
      if (result.subCategoryId) {
        this.product.subcategory = result.subCategoryId;
        this.selectedSubCategoryName =
          this.subCategories.data[result.index].name;
      }
      if (result.condition) {
        this.product.product_condition = result.conditionValue;
      }
    }
  }

  async getSubCategories() {
    this.subCategories = await this.categoryStore.getSubCategory(
      this.product.category
    );
  }

  // async informationProduct() {
  //   const modal = await this.modalCtrl.create({
  //     component: InformationProductComponent,
  //     cssClass: 'informationProduct',
  //     backdropDismiss: true,
  //   });
  //   modal.present();
  // }

  checkPrice() {
    this.product_price = parseInt(this.productForm.value.product_price);
    this.actual_price = parseInt(this.productForm.value.actual_price);
  }

  updateRentalPriceValidators(
    isRentable: boolean,
    isEditDetail: boolean = false
  ) {
    const rentalPriceControl = this.productForm.controls.rental_price;
    const whenReturnDaysControl = this.productForm.controls.when_return_days;

    if (isRentable) {
      rentalPriceControl.setValidators([Validators.required]);
      whenReturnDaysControl.setValidators([Validators.required]);
    } else {
      rentalPriceControl.clearValidators();
      whenReturnDaysControl.clearValidators();
      rentalPriceControl.setValue(null);
      whenReturnDaysControl.setValue(null);
      if (isEditDetail) {
        this.productForm.controls.is_rentable.setValue(false);
      }
    }
    rentalPriceControl.updateValueAndValidity();
    whenReturnDaysControl.updateValueAndValidity();
  }

  checkRental() {
    const isRentable = this.productForm.controls.is_rentable.value;
    this.updateRentalPriceValidators(isRentable);
  }
  async addProduct(status: number) {
    const modal = await this.modalCtrl.create({
      component: AddMoreInfoComponent,
      backdropDismiss: false,
      cssClass: 'modal-more-info',
      componentProps: { product_fields: this.product.product_fields },
    });
    await modal.present();

    const resp = await modal.onDidDismiss();
    if (resp.data) {
      this.addAdditionalInfo();
    } else {
      this.product.product_name = this.productForm.value.product_name;
      this.product.product_price = this.productForm.value.product_price;
      this.product.actual_price = this.productForm.value.actual_price
        ? this.productForm.value.actual_price
        : this.productForm.value.product_price;
      this.product.product_description =
        this.productForm.value.product_description;
      this.product.is_avail_delivery = this.productForm.value.is_avail_delivery
        ? 1
        : 0;
      this.product.is_avail_pickup = this.productForm.value.is_avail_pickup
        ? 1
        : 0;
      this.product.inventory = this.productForm.value.inventory;
      this.product.sku = this.productForm.value.sku;
      this.product.target_audience = this.productForm.value.target_audience
        ? 1
        : 0;
      this.product.is_rentable = this.productForm.value.is_rentable ? 1 : 0;
      this.product.rental_price = this.productForm.value.rental_price;
      this.product.when_return_days = this.productForm.value.when_return_days;
      this.product.storage_locations = this.authenticationStore.userInfo.seller
        .storage_locations
        ? this.authenticationStore.userInfo.seller.storage_locations.id
        : null;
      this.product.pickup_locations = this.authenticationStore.userInfo.seller
        .pickup_locations
        ? this.authenticationStore.userInfo.seller.pickup_locations.id
        : null;
      this.product.status = this.productId ? this.productDetail.status : status;

      if (status) {
        this.handleProduct(status);
      } else {
        this.saveProduct();
      }
    }
  }

  async saveProduct() {
    const alert = await this.alertController.create({
      mode: 'ios',
      header: this.translate.instant('OWN_SHOP.LEAVE_SOON_MESSAGE'),
      message: this.translate.instant('OWN_SHOP.LEAVE_ALERT'),
      cssClass: 'publish-alert',
      buttons: [
        {
          text: this.translate.instant('OWN_SHOP.DISCARD_BUTTON'),
          cssClass: 'button-gray',
          handler: () => {
            this.discardProduct();
          },
        },
        {
          text: this.translate.instant('ADD_PRODUCT_SECTION.SAVE'),
          cssClass: 'new-product',
          handler: () => {
            this.handleProduct();
          },
        },
      ],
    });
    await alert.present();
  }

  async discardProduct() {
    const alert = await this.alertController.create({
      mode: 'ios',
      cssClass: 'publish-alert',
      header: this.translate.instant('OWN_SHOP.DISCARD_ALERT'),
      message: this.translate.instant('OWN_SHOP.LEAVE_ALERT'),
      buttons: [
        {
          text: this.translate.instant('OWN_SHOP.YES'),
          cssClass: 'button-gray',
          handler: () => {
            this.router.navigate([`/my-products`]);
          },
        },
        {
          text: this.translate.instant('OWN_SHOP.GO_BACK'),
          cssClass: 'new-product',
          handler: () => {
            this.saveProduct();
          },
        },
      ],
    });
    await alert.present();
  }

  async handleProduct(status: number = null) {
    try {
      var resp: any;
      this.loaderService.showLoading();
      if (this.productId) {
        resp = await this.sellerProductStore.editSellerProduct(
          this.product,
          this.productId
        );
      } else {
        resp = await this.sellerProductStore.addSellerProduct(this.product);
      }
      this.loaderService.dismissLoading();
      var productStatus = status ? 'live' : 'saved';
      const alert = await this.alertController.create({
        header: status
          ? this.translate.instant('OWN_SHOP.PRODUCT_PUBLISH')
          : this.translate.instant('OWN_SHOP.PRODUCT_SAVE_ALERT'),
        mode: 'ios',
        message: `${this.translate.instant(
          'OWN_SHOP.PRODUCT_SAVE'
        )} ${productStatus} ${this.translate.instant('OWN_SHOP.ON_STORE')}`,
        cssClass: 'publish-alert',
        buttons: [
          {
            text: this.translate.instant('OWN_SHOP.VIEW_PRODUCT'),
            cssClass: `${!status ? 'ion-hide' : ''} view-product`,
            handler: () => {
              this.router.navigate([`/product/${resp.data.slug}`]);
            },
          },
          {
            text: this.translate.instant('OWN_SHOP.ADD_NEW_PRODUCT'),
            cssClass: 'new-product',
            handler: () => {
              this.product.product_condition = null;
              this.selectedCategoryName = 'Category';
              this.selectedSubCategoryName = 'Subcategory';
              this.subCategories = null;
              this.product.product_variation = [];
              this.product.product_fields = [];
              this.product.product_img = [];
              this.product.video_thumbnail = null;
              this.product.video_full = null;
              this.productForm.reset();
            },
          },
        ],
      });
      await alert.present();
      if (this.productId) {
        this.navController.back();
      } else {
        const navigationExtras: NavigationExtras = {
          state: {
            publish: !status ? true : false
          },
        };
        await this.router.navigate([`/my-products`], navigationExtras);
      }
    } catch (error) {
      this.loaderService.dismissLoading();
      this.loaderService.presentToast(
        error.error.data
          ? error.error.data
          : this.translate.instant('RATE_ORDER.SOMETHING_WRONG'),
        'bottom',
        'danger'
      );
    }
  }

  async addVarient(varietionIndex: number = null, varientIndex: number = null) {
    var varientData: any = {
      img: '',
      variation_type: '',
      variation_name: '',
      variation_fields: '',
      id: '',
    };
    var oldType: boolean = false;
    if (varietionIndex != null && varientIndex != null) {
      varientData =
        this.product.product_variation[varietionIndex].variant[varientIndex];
    }
    if (this.product.product_variation?.length > 0) {
      if (this.product?.product_variation[0]?.variant?.length > 0) {
        varientData.variation_type =
          this.product?.product_variation[0]?.variant[0]?.variation_type;
        oldType = true;
      }
    }
    const modal = await this.modalCtrl.create({
      component: AddVariantPage,
      cssClass: '',
      backdropDismiss: true,
      componentProps: {
        oldType: oldType,
        varientData: varientData
          ? varientData
          : {
            variation_fields: [],
            img: null,
            variation_type: null,
            variation_name: null,
          },
      },
    });
    modal.present();
    const resp = await modal.onDidDismiss();
    if (resp.data) {
      this.variations = resp.data.variations;
      var oldVariationTypeIndex = null;

      if (this.product.product_variation.length > 0) {
        oldVariationTypeIndex = this.product.product_variation.findIndex(
          (variation) => variation.id == resp.data.values.variation_type
        );
      }

      if (varietionIndex != null) {
        if (oldVariationTypeIndex == 0 || oldVariationTypeIndex > 0) {
          this.product.product_variation[varietionIndex]?.variant.splice(
            varientIndex,
            1
          );
          // if (
          //   this.product.product_variation[varietionIndex]?.variant.length == 0
          // ) {
          //   this.product.product_variation.splice(varietionIndex, 1);
          // }
          this.product.product_variation[oldVariationTypeIndex]?.variant.push(
            resp.data.values
          );
        } else {
          this.product.product_variation[varietionIndex]?.variant.splice(
            varientIndex,
            1
          );
          if (
            this.product.product_variation[varietionIndex]?.variant.length == 0
          ) {
            this.product.product_variation.splice(varietionIndex, 1);
          }
          this.product.product_variation.push({
            id: resp.data.values.variation_type,
            variation_name: this.getVariationName(
              resp.data.values.variation_type
            ),
            variant: [resp.data.values],
          });
        }
      } else {
        if (oldVariationTypeIndex == 0 || oldVariationTypeIndex > 0) {
          this.product.product_variation[oldVariationTypeIndex]?.variant.push(
            resp.data.values
          );
        } else {
          this.product.product_variation.push({
            id: resp.data.values.variation_type,
            variation_name: this.getVariationName(
              resp.data.values.variation_type
            ),
            variant: [resp.data.values],
          });
        }
      }
    }
  }

  getVariationName(type: number) {
    var resp = this.variations.filter((variation) => variation.id == type);
    return resp[0].variation_name;
  }

  async addAdditionalInfo() {
    const modal = await this.modalCtrl.create({
      component: AdditionalInformationPage,
      cssClass: '',
      backdropDismiss: true,
      componentProps: {
        product_fields: this.product.product_fields,
      },
    });
    modal.present();
    const resp = await modal.onDidDismiss();
    if (resp.data) {
      this.product.product_fields = resp.data.product_fields;
    }
  }

  async imageAction() {
    const image = await Camera.getPhoto({
      quality: 50,
      allowEditing: true,
      resultType: CameraResultType.DataUrl,
    });
    this.image = image.dataUrl;
    this.loaderService.showLoading();
    try {
      const imageUrl: any = await this.authenticationStore.imageUpload(
        image.dataUrl
      );
      this.loaderService.dismissLoading();
      this.product.product_img.push({
        thumbnail: imageUrl.data.name,
        full: imageUrl.data.full_path,
        type: 0,
        id: null,
      });
    } catch (error) {
      this.loaderService.dismissLoading();
      this.loaderService.presentToast(
        error.error.data
          ? error.error.data
          : this.translate.instant('RATE_ORDER.SOMETHING_WRONG'),
        'bottom',
        'danger'
      );
    }
  }

  async addLocation(type: number, locationData: LocationData = null) {
    const modal = await this.modalCtrl.create({
      component: AddLocationComponent,
      componentProps: {
        locationData: locationData,
        type: type,
      },
    });
    modal.present();
    const resp = await modal.onDidDismiss();
    if (resp.data) {
      if (!type) {
        this.product.storage_locations = resp.data.id;
        this.authenticationStore.userInfo.seller.storage_locations = resp.data;
      } else {
        this.product.pickup_locations = resp.data.id;
        this.authenticationStore.userInfo.seller.pickup_locations = resp.data;
      }
    }
  }

  removeVarient(varietionIndex: number, varientIndex: number) {
    this.product.product_variation[varietionIndex].variant.splice(
      varientIndex,
      1
    );
    if (this.product.product_variation[varietionIndex].variant.length == 0) {
      this.product.product_variation.splice(varietionIndex, 1);
    }
  }

  async editImage(index: number) {
    const actionSheet = await this.actionSheetCtrl.create({
      header: this.translate.instant('OWN_SHOP.EDIT_DELETE_IMAGE'),
      subHeader: '',
      buttons: [
        {
          text: this.translate.instant('OWN_SHOP.EDIT_IMAGE'),
          icon: 'create-outline',
          handler: async () => {
            const image = await Camera.getPhoto({
              quality: 50,
              allowEditing: true,
              resultType: CameraResultType.DataUrl,
            });
            this.image = image.dataUrl;
            this.loaderService.showLoading();

            try {
              const imageUrl: any = await this.authenticationStore.imageUpload(
                image.dataUrl
              );
              this.loaderService.dismissLoading();
              this.product.product_img[index].thumbnail = imageUrl.data.name;
              this.product.product_img[index].full = imageUrl.data.full_path;
            } catch (error) {
              this.loaderService.dismissLoading();
              this.loaderService.presentToast(
                error.error.data
                  ? error.error.data
                  : this.translate.instant('RATE_ORDER.SOMETHING_WRONG'),
                'bottom',
                'danger'
              );
            }
          },
        },
        {
          text: this.translate.instant('OWN_SHOP.DELETE_IMAGE'),
          icon: 'trash-outline',
          handler: async () => {
            this.product.product_img.splice(index, 1);
          },
        },
      ],
    });
    await actionSheet.present();
  }

  async VideoUploadAction() {
    if (
      this.product.video_full === null ||
      this.product.video_thumbnail === null
    ) {
      if (this.product.video_full) {
        this.addThumbAlert();
      } else {
        const fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.accept = 'video/*';
        fileInput.addEventListener('change', async (event) => {
          this.uploadVideo(event);
        });
        fileInput.click();
      }
    } else {
      const modal = await this.modalCtrl.create({
        component: VideoModalComponent,
        cssClass: 'open-image',
        componentProps: {
          video: { full: this.product.video_full },
          editOption: true,
          product: this.product,
        },
      });
      modal.present();
    }
  }

  async addThumbAlert() {
    const alert = await this.alertController.create({
      header: this.translate.instant('PLACEHOLDER_TEXT.ADD_THUMBNAIL'),
      mode: 'ios',
      message: this.translate.instant('PLACEHOLDER_TEXT.SELECT_VIDEO'),
      cssClass: 'publish-alert',
      buttons: [
        {
          text: this.translate.instant('MY_ORDERS_PAGE.CANCEL'),
          cssClass: 'button-gray',
          handler: async () => { },
        },
        {
          text: this.translate.instant('PLACEHOLDER_TEXT.ADD_THUMBNAIL'),
          cssClass: 'new-product',
          handler: async () => {
            this.uploadThumbnail();
          },
        },
      ],
    });
    await alert.present();
  }

  async uploadVideo(event) {
    const file = event.target.files[0];
    const reader: any = await new FileReader();
    reader.onloadend = async () => {
      this.base64String = await reader.result;
      this.loaderService.showLoading();
      if (this.base64String) {
        try {
          const videoPath: any = await this.authenticationStore.videoUpload({
            file_name: this.base64String,
          });
          this.loaderService.dismissLoading();
          this.product.video_full = videoPath.data.full_path;
          this.addThumbAlert();
        } catch (error) {
          this.loaderService.dismissLoading();
          this.loaderService.presentToast(
            error.error.data
              ? error.error.data
              : this.translate.instant('RATE_ORDER.SOMETHING_WRONG'),
            'bottom',
            'danger'
          );
        }
      }
    };
    await reader.readAsDataURL(file);
  }

  async uploadThumbnail() {
    const image = await Camera.getPhoto({
      quality: 50,
      allowEditing: true,
      resultType: CameraResultType.DataUrl,
    });
    this.image = image.dataUrl;
    this.loaderService.showLoading();
    try {
      const imageUrl: any = await this.authenticationStore.imageUpload(
        image.dataUrl
      );
      this.loaderService.dismissLoading();
      this.product.video_thumbnail = imageUrl?.data?.name;
    } catch (error) {
      this.loaderService.dismissLoading();
      this.loaderService.presentToast(
        error.error.data
          ? error.error.data
          : this.translate.instant('RATE_ORDER.SOMETHING_WRONG'),
        'bottom',
        'danger'
      );
    }
  }
}
